var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleplay = function SvgGoogleplay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "p8t0gxm68a",
    d: "M0.361 0.659L13.259 0.659 13.259 10.663 0.361 10.663z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tj1nppba0c",
    d: "M0.361 0.663L13.258 0.663 13.258 10.667 0.361 10.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0CF",
    d: "M.36 1.073C.144 1.3 0 1.602 0 1.957v17.427c0 .355.143.658.36.884l9.531-9.597-9.53-9.598z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .008)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a4bk8s4aob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p8t0gxm68a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00F270",
    d: "M13.259 7.272L1.959.832C1.4.514.753.66.361 1.066l9.53 9.597 3.368-3.39z",
    mask: "url(#a4bk8s4aob)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.008)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "otpvejnm3d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tj1nppba0c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FA3142",
    d: "M1.96 10.493l11.298-6.44L9.892.663.362 10.26c.391.406 1.037.552 1.597.233",
    mask: "url(#otpvejnm3d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M17.249 9.554l-3.99-2.274-3.367 3.39 3.367 3.39 3.99-2.273c.435-.248.653-.682.653-1.116 0-.435-.218-.869-.653-1.117"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleplay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "googleplay.d43492eb97c1c1e518011b9a490cbed8.svg";